export class UserLogin {
  // variables

  emailAddress: string;
  password: string;
  rememberMe: boolean;
}
